import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { FiChevronRight } from "react-icons/fi";
import { BsDot } from "react-icons/bs";


import { FiMail } from "react-icons/fi";
import './Team.css'
import anjana from '../../assets/team/anjana.jpeg'
import Hemanth from '../../assets/team/Hemanth.jpeg'
import Vishruth from '../../assets/team/Vishruth.jpg'
import Shimil from '../../assets/team/Shimil.jpg'
import Gouri from '../../assets/team/Gouri.jpg'
import jyothis from '../../assets/team/jyothis.jpg'
import Reshma from '../../assets/team/Reshma.jpg'
import Maria from '../../assets/team/Maria.jpeg'


const teamData = [
  {
    id: 1,
    name: 'Vishruth Subramanian',
    designation: 'Project Lead',
    batch: 'Batch of 2023',
    email: 'vs.vishruth.s@gmail.com',
    photo: Vishruth
  },
  {
    id: 2,
    name: 'Hemanth R',
    designation: 'Full-stack Developer',
    batch: 'Batch of 2023',
    email: 'hemanththanal@gmail.com ',
    photo: Hemanth
  },
  {
    id: 3,
    name: 'Anjana Sudevan',
    designation: 'Front-end Developer',
    batch: 'Batch of 2023',
    email: 'anjanasudevan3@gmail.com',
    photo: anjana
  },
  {
    id: 4,
    name: 'Shimil Shaji Abraham',
    designation: 'Lead UI/UX Designer',
    batch: 'Batch of 2023',
    email: 'shimilsabraham@gmail.com',
    photo: Shimil
  },
  {
    id: 5,
    name: 'Gouri Hariharan',
    designation: 'UI/UX Designer',
    batch: 'Batch of 2023',
    email: 'gourihariharan@gmail.com',
    photo: Gouri
  },
  {
    id: 6,
    name: 'Reshma J Nair',
    designation: 'Front-end Developer',
    batch: 'Batch of 2023',
    email: 'reshmajjayan@gmail.com',
    photo: Reshma
  },
  {
    id: 7,
    name: 'Jyothis K B',
    designation: 'Front-end Developer',
    batch: 'Batch of 2023',
    email: 'jyothiskb9@gmail.com',
    photo: jyothis
  },
  {
    id: 8,
    name: 'Maria J Mathew',
    designation: 'Developer',
    batch: 'Batch of 2023',
    email: 'mariajmathew21@gmail.com',
    photo: Maria
  },


]

const specialMention = ['Ashwin Girish', 'Alan Philipose', 'Arathy Sha A', 'Gowri Jayakumar', 'Alby Thekkedan', 'Lekshmi S', 'Rakhi R Panicker', 'Ribya Ann Thomas', 'Sai Lakshmi', 'Tom George', 'Bharath Raj R', 'Vineeth M Vinoy', 'Adam Oomen Jacob', 'Lisa V C', 'Alaka A J', 'Amjad Ali']
const acknowledgements = [
  'Dr. Jacob Thomas V, Prinicpal',
  'Dr. Preetha Theresa Joy, HOD',
  'Mrs. Aysha Fymin Majeed, Project Guide',
  'Mrs. Ameena K Ashraf, Project Guide',
  'Mr. Titty Jacob, System Analyst',
  'MACS',
  'All Faculty and Staff, Dept. Of Computer Engineering'
]

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0}  {...props} />
))(({ theme }) => ({
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
  borderRadius: 10
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<FiChevronRight color="#AE9142" size={25} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "#0C2340"
      : "#0C2340",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function Team() {

  const [expanded, setExpanded] = useState(false);

  const handleChange =
    (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };


  return (
    <div className='team'>
      <div className='team_container'>
        <h1>Our Team</h1>
        <div className='team_card'>
          {teamData && teamData.map((mem) => (
            <div className='team_mem' key={mem.id} data-aos="fade-up">
              <div className='team_circle'>
                <img className='team__img' src={mem.photo} loading="lazy" alt='' />
              </div>
              <div className='team_content'>
                <h1>{mem.name}</h1>
                <h3>{mem.designation}</h3>
                <h2>{mem.batch}</h2>
                <a href={`mailto:${mem.email}`}>
                  <FiMail className='team_email_icon' />
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="tp_memberaccordion">
          <Accordion
            expanded={expanded === `panel1`}
            onChange={handleChange(`panel1`)}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <h3 className="tp_teamname">Special Mention</h3>
            </AccordionSummary>
            <AccordionDetails>
              {specialMention.map((it, no) => {
                return (
                  <p key={no} className="tp_membername">
                    <BsDot className="team__bullet" color="#212121" size={22} />
                    {it}
                  </p>
                );
              })}
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="tp_memberaccordion">
          <Accordion
            expanded={expanded === `panel2`}
            onChange={handleChange(`panel2`)}
          >
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
            >
              <h3 className="tp_teamname">Acknowledgements</h3>
            </AccordionSummary>
            <AccordionDetails>
              {acknowledgements.map((it, no) => {
                return (
                  <p key={no} className="tp_membername">
                    <BsDot className="team__bullet" color="#212121" size={22} />
                    {it}
                  </p>
                );
              })}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>



  )
}

export default Team